var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-facebook",
    clipPath: "url(#clip0_2608_33707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 16.04C32 7.20804 24.832 0.0400391 16 0.0400391C7.168 0.0400391 0 7.20804 0 16.04C0 23.784 5.504 30.232 12.8 31.72V20.84H9.6V16.04H12.8V12.04C12.8 8.95204 15.312 6.44004 18.4 6.44004H22.4V11.24H19.2C18.32 11.24 17.6 11.96 17.6 12.84V16.04H22.4V20.84H17.6V31.96C25.68 31.16 32 24.344 32 16.04Z",
    fill: "#DA0D29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2608_33707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.5756a5b4936ca4eb98aed8d76b2b4c16.svg";
export { ForwardRef as ReactComponent };